import { AttachmentIcon, CloseIcon } from "@chakra-ui/icons";
import React, { useRef } from "react";
import BaseButton from "../BaseButton/BaseButton";
import BaseFlex from "../BaseFlex/BaseFlex";
import BaseInput from "../BaseInput/BaseInput";
import BaseText from "../BaseText/BaseText";

interface Props {
  accept: string;
  value: File | undefined;
  onChange: (value: File | undefined) => void;
  onDelete: () => void;
}

const UploadFile: React.FC<Props> = ({
  accept,
  value,
  onChange,
  onDelete,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = (event: React.MouseEvent) => {
    inputRef?.current?.click();
  };

  return (
    <>
      <BaseInput
        ref={inputRef}
        type="file"
        accept={accept}
        display="none"
        onChange={(event) => onChange(event.target.files?.[0])}
        {...props}
      />
      <BaseButton
        leftIcon={<AttachmentIcon />}
        variant="outline"
        onClick={handleClick}
      >
        Choose file
      </BaseButton>
      <BaseFlex align="center" gap="0.5rem">
        <BaseText
          maxWidth={{
            base: "100px",
            md: "300px",
          }}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {value?.name}
        </BaseText>

        {value && (
          <BaseButton colorScheme="red" variant="link" onClick={onDelete}>
            <CloseIcon />
          </BaseButton>
        )}
      </BaseFlex>
    </>
  );
};

export default UploadFile;
